import Cookies from 'js-cookie'
import router from '@/router';
import { notification } from 'ant-design-vue';
import store from '@/store';
const TokenKey = 'Admin-Token'



export function getToken() {
    return sessionStorage.getItem(TokenKey);
}

export function setToken(token) {
    // return Cookies.set(TokenKey, token)
    sessionStorage.setItem(TokenKey,token);
    sessionStorage.setItem('lastClickTime',(new Date()).getTime());
    if(sessionStorage.getItem('intervalX'))
    {
        try
        {
            clearInterval(sessionStorage.getItem('intervalX'));
        }
        catch (e) {

        }
    }
    sessionStorage.removeItem('intervalX');
    let x= setInterval(()=>{
        let currentTime=(new Date()).getTime();
        if((currentTime-sessionStorage.getItem('lastClickTime'))>(1000*60*10)) {
            store.commit('CLEAR_TOKEN');
            router.push({path:'/login'})
            clearInterval(x)
            notification.warn({
                message: '登录失效',
                description: '当前用户登录信息已失效！',
            });
        }
    },1000*20);
    sessionStorage.setItem('intervalX',x);
}


export function removeToken() {
    // return Cookies.remove(TokenKey)

    if(sessionStorage.getItem('intervalX'))
    {
        try
        {
            clearInterval(sessionStorage.getItem('intervalX'));
        }
        catch (e) {

        }
    }
    sessionStorage.clear();
}
